module.exports = __webpack_public_path__ + "img/Footer_4304.9e85a9c9.jpg";